module.exports = __webpack_public_path__ + "static/media/pc.b0241d36.png";